
import { Component, Vue, Watch } from 'vue-property-decorator';
import { store, StoreMutations } from '@/store';

@Component
export default class OpzioniSpedizioniComandi extends Vue {    
    
    get filtriApplicati(): boolean {
        let applicati = store.state.uiSpedizioni.filtri.numSpedizione.length > 0;
        applicati = applicati || store.state.uiSpedizioni.filtri.dataSpedizioneDa.length > 0;
        applicati = applicati || store.state.uiSpedizioni.filtri.dataSpedizioneA.length > 0;
        return applicati;
    }

    get toggleViewIcon(): string {
        return store.state.uiSpedizioni.listView ? 'mdi-apps' : 'mdi-format-list-bulleted';
    }

    private toggleView() {
        store.commit(StoreMutations.SpedizioniUiToggleListView);
    }

    
    private mostraOpzioni() {
        store.commit(StoreMutations.SetOpzioniVisibili, true);
    }
}

